import { render, staticRenderFns } from "./PortalSubtopicComponent.vue?vue&type=template&id=0999e8f2&"
import script from "./PortalSubtopicComponent.vue?vue&type=script&lang=ts&"
export * from "./PortalSubtopicComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports